import { BaseModel } from '../base-model';

export interface IPropertyManagementModel {
  ElectricityDate?: string;
  ElectricityExpert?: string;
  ElectricityExpiredDate?: string;
  ElectricityUniqueCode?: string;
  EPCDate?: string;
  EPCExpert?: string;
  GasolineDate?: string;
  GasolineExpert?: string;
  GasolineExpiredDate?: string;
  GasolineUniqueCode?: string;
  InsuranceBankAccount?: string;
  InsuranceCompanyId?: number;
  InsuranceCostPerMonth?: number;
  InsuranceCostPerYear?: number;
  InsuranceInvoiceNumber?: string;
  InsurancePaymentPer?: number;
  InsurancePaymentTo?: number;
  InsuranceStartDate?: string;
  InsuranceStatus?: true;
  InsuranceTrimester?: number;
  InsuranceType?: string;
  MgnrTransferDate?: string;
  ParticularConditions?: string;
  ParticularConditionsNL?: string;
  ParticularConditionsFR?: string;
  ParticularConditionsEN?: string;
  ParticularConditionsDE?: string;
  PropertyId?: number;
  UrbanInfoCommune?: string;
  UrbanInfoDate?: string;
  UrbanInfoNumber?: string
}
export class PropertyManagementModel extends BaseModel<IPropertyManagementModel> implements IPropertyManagementModel {

  /**
   *
   */
  constructor(option?: IPropertyManagementModel) {
    super(option)
  }
}